module.exports = __webpack_public_path__ + "assets/img/0802.30b77062.png";